$(document).ready(() => {
    $('.instant-editable').each((_index, block) => {
        const $block = $(block);
        $block.find('.content > a').click(ev => {
            ev.preventDefault();
            $block.find('input').each((_index, input) => {
                const $input = $(input);
                $input.data('original-value', $input.val());
            });
            $block.addClass('active');
        });
        $block.find('.editor > a').click(ev => {
            ev.preventDefault();
            $block.find('input').each((_index, input) => {
                const $input = $(input);
                $input.val($input.data('original-value'));
            });
            $block.removeClass('active');
        });
    });
});
